<template>
  <div class="list-modal h-card shadow">
    <div class="card-header">
      <div class="modal-title">Данные для клиента</div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <div class="p-3 small">

        <div>
          <h5>{{cabinetData.title}}</h5>
          <div>Дата: {{dateFormat}}</div>
        </div>
        Выберите необходимые часы для отправки клиенту
      </div>

      <div class="d-flex flex-column  px-3 h-100" >
        <div class="overflow-auto">
        <div class="d-flex flex-row gap-1" id="timecheck">
            <template v-for="(bData,id) in bookingData" :key="id">
              <div class="block-line">
                <div class="form-check d-flex flex-column gap-2 align-items-center">
                  <input class="form-check-input" @change="buildText" type="checkbox" checked :value="timeView(bData)" :id="id">
                  <label class="form-check-label" :for="id">
                    <span class="hourBlock">
                      <span class="block">{{ timeView1(bData) }}</span>
                      -
                      <span class="block">{{ timeView2(bData) }}</span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="mt-3 flex-fill">
          <textarea class="form-control restest"  v-model="restext" ref="restest" ></textarea>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button class="ok-btn me-1" @click="copy">Скопировать текст</button>
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>


  </div>
</template>
<script>
import {closeModal, pushModal} from "jenesius-vue-modal";
import CommentModal from "@/components/MyBookings/CommentModal.vue";
import {dateFormat} from "@/dateFormat";
import SendListDone from "@/components/MyBookings/SendListDone.vue";

export default {
  name: 'SendList',
  props: {
    bookingData: Object,
    cabinetData: Object,
    date: String,
    officeAddress: String
  },
  data() {
    return {
      restext:''
    }
  },
  mounted() {
    this.buildText();
  },
  computed: {
    dateFormat() {
      return dateFormat.strToFormat(this.date)
    },
  },
  methods: {
    copy(){
        this.$refs.restest.select();
        document.execCommand('copy');
      if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {  // IE?
        document.selection.empty();
      }
      this.copyDone();
    },
    copyDone(){
      pushModal(SendListDone)
      // alert('Текст скопирован - можете переслать клиенту!');
    },
    buildText(){
      var checkboxes = document.querySelectorAll('#timecheck input[type="checkbox"]:checked');

      var res = '';
      // res += this.cabinetData.title+"\n";
      res += 'Дата: '+ this.dateFormat+"\n";
      res += this.cabinetData.title+"\n";

      if(checkboxes.length){
        res += 'Забронированное время аренды:'+"\n";
        // var values = [];
        checkboxes.forEach(checkbox => {
          res += "    "+checkbox.value+"\n"
          // values.push(checkbox.value);
        });
        // console.log(values);
      }

      res += "\n" +'Адрес: '+this.officeAddress;
      this.restext = res;
    },
    openModalAddComment(data) {
      const props = {data: data};
      pushModal(CommentModal, props)
    },
    timeView(data) {
      return 'c '+ this.timeView1(data)+' до '+this.timeView2(data);
    },
    timeView1(data) {
      return data.hour + ':' + data.minuteView;
    },
    timeView2(data) {
      let hour = data.minuteView == '30' ? data.hour + 1 : data.hour;
      let minute = data.minuteView == '30' ? '00' : '30';
      return hour + ':' + minute;
    },
    closeCmodal() {
      closeModal();
    },
  }
}
</script>
<style scoped>
.restest{
  font-size: 0.9rem;
  height: 100%;
}
.h-100 {
  height: 100%;
}
.form-check{
  padding: 0;
}
.form-check .form-check-input{
  margin-left: 0;
}
.flex-fill {
  flex: 1 1 auto !important;
}

.change-wrap {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.add-btn-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.add-comment-btn {
  font-size: 0.7em;
  border: none;
  padding: 0.4em 1em;
  border-radius: 1em;
  background: #dd9f4c57;
  color: #704a00;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
  transition: all ease .3s;
}
.add-comment-btn:hover{
  background: #dd9f4c77;
}

.list-modal {
  width: 460px;
  max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  max-height: 95vh;
}

@container list-modal-container {
  .list-modal .card-body {
    height: 80cqh;
  }
}

.hourBlock {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4em;
  width: 4.2em;
  min-width: 4.2em;
  border: 1px solid #c7bbbb7a;
  padding: 0.1rem 0.1rem;
  border-radius: 5px;
  font-size: .7em;
  line-height: 1em;
  align-items: center;
  color: #fff;
  background: #81b29a;
  justify-content: center;
  border: 1px solid #17573800;
  box-shadow: -4px 6px 10px 0px #211e1e40;
  user-select: none;
}

.block {
  display: block;
}

.mycomment {
  font-size: .85em;
}

.mycomment.adm {
  color: #782f36;
}

.label {
  font-size: 0.65em;
  color: #9f9f9f;
}

.label.adm {
//font-size: 0.65em; //color: #c15761;
}

.block-line {

  padding: 0.2em;

}

.block-line:nth-of-type(2n) {
  background: #fff8db59;
}
</style>